import { Switch, SwitchLabel } from '@mint-lib/tw-components';

import { Separator } from './Separator.jsx';
import { useToolbarState } from './useToolbarState.js';

type ToolbarSwitchProps = {
  label: string;
  disabled?: boolean;
  size?: 'small' | 'medium';
  separator?: boolean;
  /**
   * The switch state is stored in this URL query parameter — the param is set
   * to the string `"true"` when checked and removed when unchecked. Read the
   * value back from the route's search params; there is no change callback.
   *
   * This allows the toolbar state to be bookmarked and restored from the URL.
   *
   * @example
   * // ?active=true restores the switch to the checked state
   * <ToolbarSwitch label="Active only" queryParamKey="active" />
   */
  queryParamKey: string;
};

export function ToolbarSwitch({
  label,
  disabled,
  size,
  separator,
  queryParamKey,
}: Readonly<ToolbarSwitchProps>) {
  const [checked, setChecked] = useToolbarState<boolean>(false, queryParamKey);

  return (
    <>
      <SwitchLabel>
        <Switch
          size={size ?? 'medium'}
          checked={checked}
          disabled={disabled}
          onClick={() => setChecked(!checked)}
        />
        {label}
      </SwitchLabel>
      {separator && <Separator />}
    </>
  );
}
